import { mapActions, mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'domainsPath'
    ])
  },
  methods: {
    ...mapActions([
      'handleRequest'
    ]),
    getPlanValue (list, name) {
      const found = list.find(l => l.name === name)
      return `${found.value} ${this.$i18n.t('of')} ${found.cap}`
    },
    editTeamName (currentRow, team, user, successCallback) {
      this.$prompt(this.$i18n.t('name'), this.$i18n.t('edit_team'), {
        confirmButtonText: this.$i18n.t('submit'),
        cancelButtonText: this.$i18n.t('cancel'),
        inputValue: team.name,
        inputPattern: /^(?!\s*$).+/,
        showClose: false,
        inputErrorMessage: this.$i18n.t('field_required')
      }).then(input => {
        const { domainsPath } = this
        const { value } = input
        const toUpdate = {
          name: value
        }
        const msg = this.$message(this.$i18n.t('please_wait'))
        this.handleRequest({
          name: `${domainsPath}/users/${user}/teams`,
          action: 'update',
          data: {
            id: team.id.numberStr,
            toUpdate
          }
        }).then(res => {
          msg.close()
          successCallback(res)
        })
      }).catch(() => {})
    }
  }
}
